import {Dialog, DialogTitle, DialogContent, Box, Stack, Typography, Chip, Divider, IconButton} from "@mui/material";
import {IconFileText, IconCalendar, IconDeviceSdCard, IconLayersIntersect, IconClock, IconX} from "@tabler/icons-react";
import {STATUS_COLORS} from "../../../../config/statusColors";

const formatSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
};

const formatDate = (iso) => {
    if (!iso) return "";
    return new Date(iso).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"});
};

const statusStyle = (status) => {
    if (status === "indexed") return {bg: STATUS_COLORS.success.bg, color: STATUS_COLORS.success.text};
    if (status === "processing") return {bg: STATUS_COLORS.warning.bg, color: STATUS_COLORS.warning.text};
    if (status === "failed") return {bg: STATUS_COLORS.error.bg, color: STATUS_COLORS.error.text};
    return {bg: STATUS_COLORS.info.bg, color: STATUS_COLORS.info.text};
};

const MetaBox = ({icon, label, children}) => (
    <Box sx={{bgcolor: "action.hover", borderRadius: 1.5, p: 1.5}}>
        <Stack direction={"row"} alignItems={"center"} gap={0.5}>
            {icon}
            <Typography fontSize={10} color={"text.secondary"}>{label}</Typography>
        </Stack>
        <Box sx={{mt: 0.5}}>{children}</Box>
    </Box>
);

export const DocumentPreview = ({document, open, onClose}) => {
    if (!document) return null;

    const style = statusStyle(document.status);

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"md"} fullWidth>
            <DialogTitle sx={{fontWeight: 700, fontSize: 15}}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Stack direction={"row"} alignItems={"center"} gap={1}>
                        <IconFileText size={17}/>
                        {document.name}
                    </Stack>
                    <IconButton size={"small"} onClick={onClose}>
                        <IconX size={18}/>
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack direction={"row"} gap={1.5} flexWrap={"wrap"} sx={{mb: 2}}>
                    <Box sx={{flex: "1 1 130px"}}>
                        <MetaBox icon={<IconDeviceSdCard size={12}/>} label={"Size"}>
                            <Typography fontSize={13}>{formatSize(document.size)}</Typography>
                        </MetaBox>
                    </Box>
                    <Box sx={{flex: "1 1 130px"}}>
                        <MetaBox icon={<IconLayersIntersect size={12}/>} label={"Chunks"}>
                            <Typography fontSize={13}>{document.chunks ?? "N/A"}</Typography>
                        </MetaBox>
                    </Box>
                    <Box sx={{flex: "1 1 130px"}}>
                        <MetaBox icon={<IconCalendar size={12}/>} label={"Uploaded"}>
                            <Typography fontSize={13}>{formatDate(document.uploadedAt)}</Typography>
                        </MetaBox>
                    </Box>
                    <Box sx={{flex: "1 1 130px"}}>
                        <MetaBox icon={<IconClock size={12}/>} label={"Status"}>
                            <Chip label={document.status} size={"small"}
                                  sx={{fontSize: 10, bgcolor: style.bg, color: style.color}}/>
                        </MetaBox>
                    </Box>
                </Stack>

                <Divider sx={{mb: 2}}/>

                <Typography fontSize={13} color={"text.secondary"} sx={{textAlign: "center", py: 3}}>
                    Document content is stored in LightRAG and is not available for preview.
                </Typography>
            </DialogContent>
        </Dialog>
    );
};